export const parseIdsParam = (param?: string | null): string[] =>
  (param ?? '')
    .split(',')
    .map(id => id.trim())
    .filter(Boolean)
